import Vue from 'vue';
import Router from 'vue-router';
import moment from 'moment';
import { appId, GetAppKey, appIdList } from '@/config';
import offlinePayGame from '@/config/offlinePayGame';
import { getAuth } from '@/api/account';
import { isWeiXin, isIos, getCurrentAppkey } from '@/libs/utils';

Vue.use(Router);

/**
 * meta
 * auth: 是否需要微信授权获取用户信息
 */

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      // 代币支付
      path: '/pay/wallet',
      name: 'pay.wallet',
      component: () => import('@/views/pay/wallet')
    },
    {
      path: '/offlinePay/rxzz',
      name: 'offlinePay.rxzz',
      component: () => import('@/views/offlinePay'),
      meta: {
        auth: offlinePayGame.rxzz.appId,
        appkey: offlinePayGame.rxzz.appkey
      }
    },
    {
      path: '/offlinePay/cy',
      name: 'offlinePay.cy',
      component: () => import('@/views/offlinePay'),
      meta: {
        auth: offlinePayGame.cy.appId,
        appkey: offlinePayGame.cy.appkey
      }
    },
    {
      path: '/offlinePay/lycj',
      name: 'offlinePay.lycj',
      component: () => import('@/views/offlinePay'),
      meta: {
        auth: offlinePayGame.lycj.appId,
        appkey: offlinePayGame.lycj.appkey
      }
    },
    {
      path: '/offlinePay/zzby',
      name: 'offlinePay.zzby',
      component: () => import('@/views/offlinePay'),
      meta: {
        auth: offlinePayGame.zzby.appId,
        appkey: offlinePayGame.zzby.appkey
      }
    },
    // 荣耀之怒
    {
      path: '/offlinePay/lyytj',
      name: 'offlinePay.lyytj',
      component: () => import('@/views/offlinePay'),
      meta: {
        auth: offlinePayGame.lyytj.appId,
        appkey: offlinePayGame.lyytj.appkey
      }
    },
    // 乱世龙魂
    {
      path: '/offlinePay/lslh',
      name: 'offlinePay.lslh',
      component: () => import('@/views/offlinePay'),
      meta: {
        auth: offlinePayGame.lslh.appId,
        appkey: offlinePayGame.lslh.appkey
      }
    },
    // 王者重生
    {
      path: '/offlinePay/wzcs',
      name: 'offlinePay.wzcs',
      component: () => import('@/views/offlinePay'),
      meta: {
        auth: offlinePayGame.wzcs.appId,
        appkey: offlinePayGame.wzcs.appkey
      }
    },
    // 至尊无极 王者重生游戏
    {
      path: '/offlinePay/zzwj',
      name: 'offlinePay.zzwj',
      component: () => import('@/views/offlinePay'),
      meta: {
        auth: offlinePayGame.zzwj.appId,
        appkey: offlinePayGame.zzwj.appkey
      }
    },
    // 帝王荣耀 安卓包 赤焰游戏
    {
      path: '/offlinePay/dwryAndroid',
      name: 'offlinePay.dwryAndroid',
      component: () => import('@/views/offlinePay'),
      meta: {
        auth: offlinePayGame.dwryAndroid.appId,
        appkey: offlinePayGame.dwryAndroid.appkey
      }
    },
    // 单独的一条连接，跳转其他线下支付链接
    {
      path: '/offlinePay/collect',
      name: 'offlinePay.collect',
      component: () => import('@/views/offlinePay/collect'),
      meta: {
        auth: offlinePayGame.lyytj.appId,
        appkey: offlinePayGame.lyytj.appkey
      }
    },
    {
      path: '/offlinePay/yycs',
      name: 'offlinePay.yycs',
      component: () => import('@/views/offlinePay'),
      meta: {
        auth: offlinePayGame.yycs.appId,
        appkey: offlinePayGame.yycs.appkey
      }
    },
    {
      path: '/miniGameCharge',
      name: 'miniGameCharge', 
      component: () => import("@/views/miniGameCharge"),
      meta: {
        auth: 'wxdfe94bc104c6a12a',
        appkey: '100008656',
        ywAppkey: '300000004'
      }
    },
    {
      path: '/multiCharge',
      name: 'multiCharge', 
      component: () => import("@/views/multiCharge"),
      meta: {
        auth: 'wxdfe94bc104c6a12a',
        appkey: '100008656',
        ywAppkey: '300000004'
      }
    },
    {
      path: '/offline/transfer',
      name: 'offline.transfer', 
      component: () => import("@/views/transfer"),
      meta: {
        auth: 'wxdfe94bc104c6a12a',
        appkey: '100008656',
        ywAppkey: '300000004'
      }
    },
    {
      // 微小切用户线下充值
      path: '/leadCharge',
      name: 'leadCharge',
      component: () => import("@/views/leadCharge"),
      meta: {
        auth: 'wxdfe94bc104c6a12a',
        appkey: '100008656',
        ywAppkey: '300000004'
      }
    },
    { path: '*', redirect: '/pay/wallet' }
  ]
});

const handleQuery = query => {
  let arr = [];
  for (let it in query) {
    arr.push(`${it}=${query[it]}`);
  }
  arr = arr.join('_AND_');
  return arr;
};

const composeQuery = query => {
  let arr = query.split('_AND_');
  return `?${arr.join('&')}`;
};

/**
 * 从 state 字符串解析出原始 query 对象
 * state 格式: key1=value1_AND_key2=value2
 */
const parseState = (state) => {
  if (!state) return {};
  const obj = {};
  state.split('_AND_').forEach(item => {
    const [key, value] = item.split('=');
    if (key) obj[key] = value;
  });
  return obj;
};

/**
 * 获取微信授权 appId
 * 优先级: query.wx_app_id > state中的wx_app_id > meta.auth
 */
const getWxAppId = (route) => {
  if (route.query.wx_app_id) return route.query.wx_app_id;
  if (route.query.state) {
    const stateObj = parseState(route.query.state);
    if (stateObj.wx_app_id) return stateObj.wx_app_id;
  }
  return route.meta.auth;
};

const handleLocationSearch = () => {
  // ?code=071ooabY1ZDee01tmA9Y1tsUaY1ooabb&state=gameCircle.home_HM_circleId%3D3
  try {
    let search = decodeURIComponent(window.location.search);
    search = search.slice(1);
    let obj = {};
    search = search.split('&');
    search.map(item => {
      let param = item.split('=');
      obj[param[0]] = param[1];
    });
    return obj;
  } catch (e) {
    console.log('handleLocationSearch', e);
    return {};
  }
};

router.beforeEach(async (to, from, next) => {
  const { code, state } = to.query;

  // 非微信浏览器不跳
  if (!isWeiXin()) {
    next();
    return;
  }
  if (code) {
    const wxAppId = getWxAppId(to);
    let params = { code, wx_app_id: wxAppId, appkey: getCurrentAppkey(to) };
    const r = await getAuth(params);
    localStorage.setItem('is_snapshotuser', r.content.is_snapshotuser);
    localStorage.setItem('userInfo', JSON.stringify(r.content));
    localStorage.setItem('timestamp', moment().unix());
    localStorage.setItem('appId', wxAppId);
    if (state) {
      window.location.replace(`${window.location.protocol}//${window.location.hostname}${to.path}${composeQuery(state)}`);
    } else {
      window.location.replace(`${window.location.protocol}//${window.location.hostname}${to.path}`);
    }
    return;
  }

  // 需要获取用户微信信息的页面
  const wxAppIdForAuth = getWxAppId(to);
  if (wxAppIdForAuth) {
    const userInfo = localStorage.getItem('userInfo');
    const lastAppId = localStorage.getItem('appId');
    const lastTimestamp = localStorage.getItem('timestamp') || 0;
    const timestamp = moment().unix();
    // 上次拉取是否超过一天
    const expireState = timestamp - Number(lastTimestamp) > 60 * 60 * 24;
    if (!userInfo || expireState || lastAppId !== wxAppIdForAuth) {
      const redirect_uri = encodeURIComponent(`${window.location.protocol}//${window.location.hostname}${to.fullPath}`);
      const state = handleQuery(to.query);
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${wxAppIdForAuth}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base&state=${state}#wechat_redirect`;
    } else {
      next();
    }
  } else {
    next();
  }
});

router.afterEach((to, from) => {
  // if (isIos()) {
  //   setTimeout(() => {
  //     const href = window.location.href;
  //     if (!window.location.search) {
  //       window.location.href = `${href}?v=123`
  //     } else {
  //       const { v } = handleLocationSearch();
  //       if (!v) {
  //         window.location.href = `${href}&v=123`
  //       }
  //     }
  //   }, 500);
  // }
});

export default router;
